import { render } from "./AddEditFormRecordView.vue?vue&type=template&id=2f504784"
import script from "./AddEditFormRecordView.vue?vue&type=script&lang=js"
export * from "./AddEditFormRecordView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__